export enum DANCER_SORTS {
  NAME = 'NAME',
  SCORE = 'SCORE',
  CREATED_AT = 'CREATED_AT'
}

